import { Tabs } from '@mantine/core'
import { useLocation, useNavigate } from 'react-router-dom'

const items = [
  { label: 'Insurance Plans', value: '/settings/insurance-plans' },
  { label: 'Terminology', value: '/settings/terminology' },
  { label: 'Organization Connects', value: '/settings/connects' },
]

export function Navigation() {
  const location = useLocation()
  const navigate = useNavigate()

  return (
    <Tabs
      variant="outline"
      defaultValue={location.pathname}
      className="sticky top-16 z-11 bg-white"
      classNames={{
        list: '!bg-primary',
        tab: 'data-[active=true]:!bg-white aria-[selected=false]:!text-white aria-[selected=false]:hover:!opacity-80',
      }}
    >
      <Tabs.List>
        {items.map((item) => (
          <Tabs.Tab value={item.value} key={item.value} onClick={() => navigate(item.value)}>
            {item.label}
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs>
  )
}
